import {
  boolean,
  dateOptional,
  stringOptional,
  timeStampEpochRequired,
  phoneCodeRequired,
  phoneNumberRequired,
  stringRequired,
  enumRequired,
  labeled
} from '../../util/joi';
import { schema as contactPersonEmploymentCode } from './ContactPersonEmploymentCode.schema';
import { schema as addressSchema } from '../address/Address.schema';

import { contactEmploymentPriorities } from './ContactEmploymentPriority.enum';
import { contactEmploymentTypes } from './ContactEmploymentType.enum';
import { contactEmploymentBases } from './ContactEmploymentBasis.enum';
import { personalTitles } from '../global/PersonalTitle.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      status: enumRequired(Joi, contactEmploymentPriorities, labeled(label, 'Status')),
      type: enumRequired(Joi, contactEmploymentTypes, labeled(label, 'Type')),
      isCurrent: boolean(Joi).label(labeled(label, 'Current'))
    })
    .when('.type.name', {
      is: Joi.valid('salaried_employee', 'self_employed'),
      then: {
        basis: enumRequired(Joi, contactEmploymentBases, labeled(label, 'Basis')),
        role: stringRequired(Joi, 1, 64).label(labeled(label, 'Occupation')),
        employerName: stringRequired(Joi, 1, 64).label(labeled(label, 'Name')),
        employerAddress: addressSchema(Joi, labeled(label, 'Employer address -')),
        employerContactTitle: enumRequired(Joi, personalTitles, labeled(label, 'Title')),
        employerContactFirstName: stringRequired(Joi, 1, 64).label(
          labeled(label, 'Contact first name')
        ),
        employerContactSurname: stringRequired(Joi, 1, 64).label(
          labeled(label, 'Contact family name')
        ),
        employerPhoneCode: phoneCodeRequired(Joi).label(labeled(label, 'Phone code')),
        employerPhone: phoneNumberRequired(Joi).label(labeled(label, 'Phone number')),
        employerType: boolean(Joi).label(labeled(label, 'Type')),
        employerAbn: stringOptional(Joi, 1, 64).label(labeled(label, 'ABN')),
        employerAcn: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: stringOptional(Joi, 1, 64).label(labeled(label, 'ACN'))
        }),
        startDate: timeStampEpochRequired(Joi).label(labeled(label, 'Start date')),
        endDate: Joi.alternatives().conditional('isCurrent', {
          is: false,
          then: timeStampEpochRequired(Joi).label(labeled(label, 'End date')),
          otherwise: dateOptional(Joi).label(labeled(label, 'End date'))
        }),
        absOccupationCode: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: contactPersonEmploymentCode(Joi, labeled(label, 'ABS -'))
        }),
        anzscoIndustryCode: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: contactPersonEmploymentCode(Joi, labeled(label, 'ANZCO -'))
        }),
        probationExpiryDate: dateOptional(Joi).label(labeled(label, 'Probation expiry date')),
        onProbation: boolean(Joi).label(labeled(label, 'On probation'))
      }
    });

export default {
  schema
};
